import moment from "moment/moment";

export const getTimeFromConfig = (configTime) => {
  return moment(configTime, "YYYY-MM-DD hh:mm").utcOffset("+0700").valueOf();
};

export const getTimeNow = () => {
  return moment(Date.now()).utcOffset("+0700").valueOf();
};

export const getTimeVote = (config) => {
  const times = config.times;
  let start = 0;
  let end = 0;

  const now = getTimeNow();
  if (times && times.length > 0) {
    start = getTimeFromConfig(times[0].start);
    end = getTimeFromConfig(times[0].end);

    times.forEach((element) => {
      const startTime = getTimeFromConfig(element.start);

      const endTime = getTimeFromConfig(element.end);

      if (now >= startTime) {
        start = startTime;
        end = endTime;
      }
    });
  }

  return { start, end };
};

export const checkTimeVote = () => {
  try {
    const now = getTimeNow();

    const { start, end } = getTimeVote();

    if (now < start || now > end) {
      return false;
    }

    return true;
  } catch (error) {
    console.log("xxxxx checkTimeVote err", error);
    return false;
  }
};
